// src/components/TitleManager.jsx
import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";

const APP_NAME = "پنل فاکتور";

const TITLES = [
  { path: "/login", title: "ورود" },

  { path: "/dashboard", title: "داشبورد" },
  { path: "/dashboard/settings", title: "تنظیمات" },

  { path: "/dashboard/products", title: "محصولات" },
  { path: "/dashboard/products/:id/edit", title: "ویرایش محصول" },

  { path: "/dashboard/customers", title: "مشتریان" },
  { path: "/dashboard/customers/:id/edit", title: "ویرایش مشتری" },

  { path: "/dashboard/factors", title: "فاکتورها" },
  { path: "/dashboard/factors/new", title: "فاکتور جدید" },
  { path: "/dashboard/factors/:id/edit", title: "ویرایش فاکتور" },
  { path: "/dashboard/factors/:id/print", title: "چاپ فاکتور (نوع ۱)" },
  { path: "/dashboard/factors/:id/print2", title: "چاپ فاکتور (نوع ۲)" },

  { path: "/dashboard/transactions", title: "تراکنش‌ها" },
  { path: "/dashboard/transactions/new", title: "تراکنش جدید" },
  { path: "/dashboard/transactions/:id/edit", title: "ویرایش تراکنش" },

  { path: "/dashboard/ledger", title: "دفتر کل" },
  { path: "/dashboard/ledger/:customerId/print", title: "چاپ دفتر کل" },

  { path: "/dashboard/letters", title: "نامه‌ها" },
  { path: "/dashboard/letters/new", title: "نامه جدید" },
  { path: "/dashboard/letters/:id/edit", title: "ویرایش نامه" },
  { path: "/dashboard/letters/:id/print", title: "چاپ نامه" },

  { path: "/dashboard/logs", title: "گزارش فعالیت‌ها" },
];

export default function TitleManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const hit = TITLES.find((t) =>
      matchPath({ path: t.path, end: true }, pathname)
    );
    document.title = hit ? `${hit.title} | ${APP_NAME}` : APP_NAME;
  }, [pathname]);

  return null;
}